// src/hooks/useMoto.js
import { useCallback, useEffect, useState } from "react";
import { getMoto, ensureValorRebajadoDefault } from "../services/motos";

export const useMoto = (id) => {
  const [moto, setMoto] = useState(null);
  const [loading, setLoading] = useState(true);

  // Memoizamos refresh para que sea estable y apto para el array de deps del useEffect
  const refresh = useCallback(async () => {
    setLoading(true);
    let isCancelled = false;

    try {
      const m = await getMoto(id);
      if (!isCancelled) {
        setMoto(m ? ensureValorRebajadoDefault(m) : null);
      }
    } catch (e) {
      if (!isCancelled) {
        console.error("Error al obtener moto:", e);
        setMoto(null);
      }
    } finally {
      if (!isCancelled) setLoading(false);
    }

    // cleanup para evitar setState después de unmount
    return () => {
      isCancelled = true;
    };
  }, [id]);

  useEffect(() => {
    const cleanup = refresh();
    return () => {
      // Si refresh devolvió un cleanup (por si en el futuro cambias la impl)
      if (typeof cleanup === "function") cleanup();
    };
  }, [refresh]);

  return { moto, setMoto, loading, refresh };
};